import {
  Component,
  Input,
  Output,
  OnInit,
  ViewChild,
  EventEmitter
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import {
  BluePrintTicket,
  Ticket,
  User,
  Attachment,
  Thread,
  UserAbility,
  TakeTicketLogData,
  AssignTicketLogData,
  ChangeDivisionLogData,
  SolveTicketLogData
} from '../../_shared/models';
import {
  TicketService,
  UserService,
  LoadingService,
  AuthenticationService,
  TicketAttachmentService
} from '../../_shared/services';
import { Granule } from '../../config';
import { Subscription } from 'rxjs/Rx';

@Component({
  selector: 'app-ticket-detail',
  templateUrl: './ticket-detail.component.html',
  styleUrls: [
    '../../../assets/css/core-navbar.css',
    '../_css-ticket/ticket-content.css',
    './ticket-detail.component.css',
    '../_css-ticket/ticket-content-mobile-responsive-detail.css',
    '../ticket-thread/ticket-thread.component.css'
  ]
})
export class TicketDetailComponent implements OnInit {
  @Input('selectedTicket') private selectedTicket: Ticket;
  @Input() private isDetailShown: boolean;
  @Output() private changeShown = new EventEmitter<string>();
  @ViewChild('attachfile') attachfile: any;
  private user: User = new User();
  private replyClass = 'btn-left btn-no-bg';
  private replyThread = new Thread();
  private updateTicket = new BluePrintTicket();
  private userAbility = new UserAbility();
  private notifErrorModal = false;
  private notifSuccessModal = false;
  private isAttachmentUploaded = new Array<boolean>();
  private ticketid: string;
  private attachmentSubscriber = new Subscription();
  private formData: FormData = new FormData();
  private solveButtonState = '';
  public errorMessages: string;
  public successMessage: string;

  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;

  constructor(
    private route: ActivatedRoute,
    private granule: Granule,
    private ticketService: TicketService,
    private userService: UserService,
    private loadingService: LoadingService,
    private authenticationService: AuthenticationService,
    private ticketAttachmentService: TicketAttachmentService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.replyThread.attachments = new Array<Attachment>();

    // subscribe to user info changes
    this.authenticationService.userInfo.subscribe(userInfo => {
      this.user = userInfo;
      this.userAbility.can_take = userInfo.ability.can_take;
    });
    this.updateTicket = this.selectedTicket;
  }

  backMobile() {
    this.changeShown.emit('BackToList');
  }

  actionMobile() {
    this.changeShown.emit('GoToAction');
  }

  closeNotifModal() {
    this.notifErrorModal = false;
    this.notifSuccessModal = false;
    this.errorMessages = null;
  }

  // listen to file change event in attach button
  fileChange(event: any) {
    const fileList: FileList = event.target.files; // get files from change event in browse button
    let validation = this.ticketAttachmentService.attachmentsValidation(
      fileList
    );
    if (validation.success) {
      this.appendAttachments(fileList, validation.data);
    } else {
      this.openNotifModal(validation.errors);
    }
    this.attachfile.nativeElement.value = '';
  }

  appendAttachments(fileList: FileList, type: string) {
    if (!this.formData.has('ticketid')) {
      this.formData.append('ticketid', this.updateTicket.ticket_id);
    }
    let fileCount = fileList.length;
    for (let i = 0; i < fileCount; i++) {
      this.addAttachmentItem(fileList[i].name, type, fileList[i].size);
      // append each attachments to this.formData
      this.formData.append('attachment[]', fileList[i], fileList[i].name);
      this.formData.append('attachmentsize[]', fileList[i].size.toString());
      // set isAttachmentUploaded array into false
      this.isAttachmentUploaded.push(false);

      // add attachment in server
      this.addAttachmentInServer();
    }
  }

  addAttachmentInServer() {
    // hit api endpoint using service here
    let x = 0;
    this.attachmentSubscriber = this.ticketAttachmentService
      .uploadAttachment(this.formData)
      .subscribe(res => {
        for (let i = 0; i < this.replyThread.attachments.length; i++) {
          if (this.replyThread.attachments[i].hashedfilename == null) {
            this.replyThread.attachments[i].hashedfilename = res.data[x];
            x++;

            // change isAttachmentUploaded into true
            this.isAttachmentUploaded.pop();
            this.isAttachmentUploaded.unshift(true);
          }
        }
      });

    // after posting data, reset the value in formData to avoid duplicate file upload
    this.formData.delete('attachment[]');
    this.formData.delete('attachmentsize[]');
  }

  hideReplyTicket() {
    this.replyClass = 'btn-left btn-no-bg';
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  onSubmit() {
    let replyTicket = new BluePrintTicket();
    replyTicket.ticket_id = this.selectedTicket.ticket_id;
    replyTicket.thread = [];
    this.replyThread.created_by = this.user._id;
    replyTicket.thread.push(this.replyThread);
    replyTicket.status = 'Replied';

    this.ticketService.replyTicket(replyTicket).subscribe(
      res => {
        this.selectedTicket.thread = res.data.thread;
        this.selectedTicket.thread_replier_detail =
          res.data.thread_replier_detail;
        this.selectedTicket.updated_at = res.data.updated_at;
        this.selectedTicket.status = res.data.status;
      },
      x => {
        /* this function is executed when there's an ERROR */
        console.log('ERROR: ' + x);
      },
      () => {
        /* this function is executed when the observable ends (completes) its stream */
        console.log('Completed', 'Ticket has been replied!');
        this.successMessage = 'Ticket has been replied!';
        this.formData = new FormData(); // gak bisa di delete gtu, jadi sepertinya mesti re initialize?
        this.replyThread = new Thread();
        this.replyThread.attachments = new Array<Attachment>();
      }
    );
  }

  openNotifModal(message: string) {
    this.errorMessages = message;
    this.notifErrorModal = true;
  }

  addAttachmentItem(name: string, extension: string, size: number) {
    const attachment = new Attachment();
    attachment.filename = name;
    attachment.extension = extension;
    attachment.filesize = size;
    attachment.hashedfilename = null;

    this.replyThread.attachments.push(attachment);
  }

  cancelTicket() {
    // reset form
    this.replyThread = new Thread();

    // remove all attachment + directory in server endpoint
    this.ticketAttachmentService.removeAttachmentDirectory(
      this.selectedTicket.ticket_id
    );

    // remove all files in newTicketModels
    this.replyThread.attachments = [];
    // remove each attachments to formData
    this.formData.delete('attachment[]');
  }

  removeAttachmentInReplyTicket(i: number, hashedfilename: string) {
    // remove attachment in model
    this.replyThread.attachments.splice(i, 1);

    // remove attachment in server
    this.removeAttachmentInServer(i, hashedfilename);
  }

  removeAttachmentInServer(i: number, hashedfilename: string) {
    if (hashedfilename !== null) {
      // hit api endpoint using service here
      this.ticketAttachmentService.removeAttachment(hashedfilename).subscribe(
        res => {},
        err => {},
        () => {
          // splice attachment status
          this.isAttachmentUploaded.splice(i, 1);

          // remove attachment in model
          this.replyThread.attachments.splice(i, 1);
        }
      );
    }
  }

  showReplyTicket() {
    this.replyClass = 'btn-left btn-no-bg btn-click';
  }

  solveTicket() {
    const solvedata: SolveTicketLogData = {
      ticket_id: this.selectedTicket.ticket_id,
      marked_solved_by: this.user._id,
      status: 'Solved'
    };

    this.ticketService.solveTicket(solvedata).subscribe(
      res => {
        this.selectedTicket.status = res.data.status;
      },
      x => {
        /* this function is executed when there's an ERROR */
        console.log('ERROR: ' + x);
      },
      () => {
        /* this function is executed when the observable ends (completes) its stream */
        console.log('Completed', 'Ticket has marked as solved!');
        this.successMessage = 'Ticket has marked as solved!';
      }
    );
  }

  takeTicket() {
    const data: TakeTicketLogData = {
      Log: {
        taken_by: this.user._id
      },
      status: 'Open',
      ticket_id: this.selectedTicket.ticket_id
    };
    const self = this;

    console.log(data);
    this.ticketService.setLabelAndAssign(data).subscribe(
      res => {
        console.log('VALUE RECEIVED: ', res);
        self.selectedTicket.taken_by = res.data.taken_by;
      },
      x => {
        /* this function is executed when there's an ERROR */
        console.log('ERROR: ' + x);
      },
      () => {
        /* this function is executed when the observable ends (completes) its stream */
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/ticket/ticket-detail/ticket-detail.component.ts